import { createSvgIcon } from '@mui/material';

export const JCBIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19243_22606)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#E7EBFA'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M35.6695 20.3738C35.6695 21.9521 34.3844 23.2373 32.8061 23.2373H17.2261V11.8962C17.2261 10.3179 18.5113 9.03271 20.0895 9.03271H35.6695V20.3738Z'
        fill='white'
      />
      <path
        d='M31.6451 9.99121C30.5177 9.99121 29.5933 10.9044 29.5933 12.043V14.1737H32.4906C32.5582 14.1737 32.6372 14.1737 32.6935 14.1849C33.3474 14.2188 33.8321 14.557 33.8321 15.1432C33.8321 15.6054 33.5052 16 32.8964 16.0789V16.1014C33.5616 16.1465 34.0689 16.5186 34.0689 17.0935C34.0689 17.7135 33.5052 18.1194 32.7612 18.1194H29.582V22.2906H32.5921C33.7194 22.2906 34.6438 21.3774 34.6438 20.2388V9.99121H31.6451Z'
        fill='url(#paint0_linear_19243_22606)'
      />
      <path
        d='M30.5967 17.4655H31.7804C31.7974 17.4655 31.8255 17.4627 31.8537 17.4599C31.8819 17.4571 31.9101 17.4543 31.927 17.4543C32.1525 17.4092 32.3441 17.2062 32.3441 16.9244C32.3441 16.6538 32.1525 16.4509 31.927 16.3945C31.8932 16.3833 31.8255 16.3833 31.7804 16.3833H30.5967V17.4655Z'
        fill='url(#paint1_linear_19243_22606)'
      />
      <path
        d='M31.7804 14.7937C32.0059 14.8275 32.1976 15.0079 32.1976 15.2785C32.1976 15.549 32.0059 15.7294 31.7804 15.7632C31.7692 15.7745 31.7015 15.7745 31.6677 15.7745H30.5967V14.7824H31.6677C31.6863 14.7824 31.7118 14.7859 31.7347 14.7889C31.7533 14.7914 31.7703 14.7937 31.7804 14.7937Z'
        fill='url(#paint2_linear_19243_22606)'
      />
      <path
        d='M20.3038 9.99121C19.1764 9.99121 18.252 10.9044 18.252 12.043V17.1048C18.8269 17.3866 19.4244 17.567 20.0219 17.567C20.7322 17.567 21.1155 17.1386 21.1155 16.5524V14.1624H22.8741V16.5411C22.8741 17.4655 22.2992 18.2208 20.3489 18.2208C19.1652 18.2208 18.2407 17.9616 18.2407 17.9616V22.2793H21.2507C22.3781 22.2793 23.3025 21.3661 23.3025 20.2275V9.99121H20.3038Z'
        fill='url(#paint3_linear_19243_22606)'
      />
      <path
        d='M25.9744 9.99121C24.847 9.99121 23.9226 10.9044 23.9226 12.043V14.7261C24.4412 14.2864 25.3431 14.0046 26.7974 14.0722C27.5752 14.106 28.4095 14.3202 28.4095 14.3202V15.1883C27.9923 14.9741 27.4963 14.7824 26.8537 14.7373C25.7489 14.6584 25.0838 15.1996 25.0838 16.1465C25.0838 17.1048 25.7489 17.6459 26.8537 17.5557C27.4963 17.5106 27.9923 17.3077 28.4095 17.1048V17.9728C28.4095 17.9728 27.5865 18.187 26.7974 18.2208C25.3431 18.2885 24.4412 18.0066 23.9226 17.567V22.3018H26.9326C28.06 22.3018 28.9844 21.3887 28.9844 20.2501V9.99121H25.9744Z'
        fill='url(#paint4_linear_19243_22606)'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19243_22606'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19243_22606'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19243_22606'
          result='effect2_dropShadow_19243_22606'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19243_22606'
          result='shape'
        />
      </filter>
      <linearGradient
        id='paint0_linear_19243_22606'
        x1='29.5914'
        y1='15.2771'
        x2='34.6576'
        y2='15.2771'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#007940' />
        <stop offset='0.2285' stopColor='#00873F' />
        <stop offset='0.7433' stopColor='#40A737' />
        <stop offset='1' stopColor='#5CB531' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_19243_22606'
        x1='29.5914'
        y1='15.2771'
        x2='34.6576'
        y2='15.2771'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#007940' />
        <stop offset='0.2285' stopColor='#00873F' />
        <stop offset='0.7433' stopColor='#40A737' />
        <stop offset='1' stopColor='#5CB531' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_19243_22606'
        x1='29.5914'
        y1='15.2771'
        x2='34.6576'
        y2='15.2771'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#007940' />
        <stop offset='0.2285' stopColor='#00873F' />
        <stop offset='0.7433' stopColor='#40A737' />
        <stop offset='1' stopColor='#5CB531' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_19243_22606'
        x1='18.2496'
        y1='16.136'
        x2='23.3941'
        y2='16.136'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1F286F' />
        <stop offset='0.4751' stopColor='#004E94' />
        <stop offset='0.8261' stopColor='#0066B1' />
        <stop offset='1' stopColor='#006FBC' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_19243_22606'
        x1='23.8935'
        y1='16.136'
        x2='28.8899'
        y2='16.136'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#6C2C2F' />
        <stop offset='0.1735' stopColor='#882730' />
        <stop offset='0.5731' stopColor='#BE1833' />
        <stop offset='0.8585' stopColor='#DC0436' />
        <stop offset='1' stopColor='#E60039' />
      </linearGradient>
    </defs>
  </svg>,
  'JCBIcon',
);
